// User Roles
export const USER_ROLE_APPROVER = "APPROVER";
export const USER_ROLE_ADMIN = "ADMIN";
export const USER_ROLE_MDC_ADMIN = "MDC_ADMIN";
export const USER_ROLE_API_USER = "API_USER";
export const USER_ROLE_SUPPORT = "SUPPORT";
export const USER_ROLE_EXPERT = "EXPERT";
export const USER_ROLE_ACCOUNTANT = "ACCOUNTANT";

export const userRoles = [
  USER_ROLE_APPROVER,
  USER_ROLE_SUPPORT,
  USER_ROLE_ACCOUNTANT,
  USER_ROLE_EXPERT,
  USER_ROLE_MDC_ADMIN,
  USER_ROLE_ADMIN,
  USER_ROLE_API_USER,
];

export const clientRoles = [USER_ROLE_APPROVER, USER_ROLE_ADMIN];
export const backStageRoles = [
  USER_ROLE_SUPPORT,
  USER_ROLE_ACCOUNTANT,
  USER_ROLE_EXPERT,
  USER_ROLE_MDC_ADMIN,
];

export const QES_CURRENT_STAGE = {
  NOTIFICATION: "notification",
  IDENT: "ident",
  VERIFY: "verify",
  SIGN: "sign",
};
export const QES_STAGE_STATUS = {
  STARTED: "started",
  COMPLETED: "completed",
};

// NP QES stepper mapping (4 steps). Returns the MUI `activeStep` index:
// steps with index < value are ticked, the step at index === value is active.
//   notification + started   -> 0 (Step 1 active)
//   notification + completed -> 1 (Step 1 ticked)
//   ident + started          -> 1 (Step 1 ticked, Step 2 active)
//   ident + completed        -> 2 (Steps 1,2 ticked)
//   sign + started           -> 2 (Steps 1,2 ticked, Step 3 active)
//   sign + completed         -> 4 (all steps ticked)
export const getNPQESStepperValue = (signingStatus) => {
  const currentStage = signingStatus?.currentStage?.toLowerCase();
  const isCompleted =
    signingStatus?.stageStatus?.toLowerCase() ===
    QES_STAGE_STATUS.COMPLETED.toLowerCase();

  if (currentStage === QES_CURRENT_STAGE.SIGN) {
    return isCompleted ? 4 : 2;
  }
  if (currentStage === QES_CURRENT_STAGE.IDENT) {
    return isCompleted ? 2 : 1;
  }
  if (currentStage === QES_CURRENT_STAGE.NOTIFICATION) {
    return isCompleted ? 1 : 0;
  }
  return 0;
};

// JP QES stepper mapping (4 steps). Same as NP for notification/ident/sign,
// but `verify` is a no-action stage: returns null so the caller keeps the
// previous step instead of moving the stepper.
//   verify + started/completed -> null (no action)
//   notification + completed   -> 1 (Step 1 ticked)
//   ident + started            -> 1 (Step 1 ticked, Step 2 active)
//   ident + completed          -> 2 (Steps 1,2 ticked)
//   sign + started             -> 2 (Steps 1,2 ticked, Step 3 active)
//   sign + completed           -> 4 (all steps ticked)
export const getJPQESStepperValue = (signingStatus) => {
  const currentStage = signingStatus?.currentStage?.toLowerCase();
  const isCompleted =
    signingStatus?.stageStatus?.toLowerCase() ===
    QES_STAGE_STATUS.COMPLETED.toLowerCase();

  if (currentStage === QES_CURRENT_STAGE.VERIFY) {
    return null;
  }
  if (currentStage === QES_CURRENT_STAGE.SIGN) {
    return isCompleted ? 4 : 2;
  }
  if (currentStage === QES_CURRENT_STAGE.IDENT) {
    return isCompleted ? 2 : 1;
  }
  if (currentStage === QES_CURRENT_STAGE.NOTIFICATION) {
    return isCompleted ? 1 : 0;
  }
  return 0;
};

export const userConstants = {
  REGISTER_REQUEST: "USERS_REGISTER_REQUEST",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  REGISTER_FAILURE: "USERS_REGISTER_FAILURE",

  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",

  LOGOUT_SUCCESS: "USERS_LOGOUT_SUCCESS",

  GETALL_REQUEST: "USERS_GETALL_REQUEST",
  GETALL_SUCCESS: "USERS_GETALL_SUCCESS",
  GETALL_FAILURE: "USERS_GETALL_FAILURE",

  DELETE_REQUEST: "USERS_DELETE_REQUEST",
  DELETE_SUCCESS: "USERS_DELETE_SUCCESS",
  DELETE_FAILURE: "USERS_DELETE_FAILURE",

  GRANT_TYPE: "password",

  USER_UPDATE: "USER_UPDATE",

  COMPANY_DETAILS_SUCCESS: "COMPANY_DETAILS_SUCCESS",

  // Verimi Register
  VERIMI_REGISTER_SUCCESS: "VERIMI_REGISTER_SUCCESS",

  GET_PRODUCT_VERSION_SUCCESS: "GET_PRODUCT_VERSION_SUCCESS",

  GET_EXCEL_TEMPALTE_SUCCESS: "GET_EXCEL_TEMPALTE_SUCCESS",

  GET_TEMPALTE_PDF_SUCCESS: "GET_TEMPALTE_PDF_SUCCESS",

  GET_TENANT_LIST_SUCCESS: "GET_TENANT_LIST_SUCCESS",

  SET_LOGOUT_WARNING_TIMER: "SET_LOGOUT_WARNING_TIMER",
};

export const SCOPE_DETAILS_HEADING_LABELS = [
  "Nutzerinformationen",
  "Scope Details",
];

export const SCOPE_DETAILS_PRIMARY_KEYS = {
  given_name: "Name",
  family_name: "Vorname",
  email: "E-Mail Adresse",
};

export const SCOPE_DETAILS_SECONDARY_KEYS = {
  // scopeId: "Scope ID",
  // basketId: "Basket ID",
  // procuration: "Procuration",
  // serviceProviderId: "Service Provider ID",
  role: "Role",
};

export const SCOPE_DETAILS_EMPLOYEE_ID = "Employee ID";

export const EMPLOYEE_ID_VALIDATION_ERRORS = [
  "Die Mitarbeiternummer darf nicht leer sein oder Leerzeichen beinhalten. Bitte überprüfen Sie Ihre Eingabe.",
  "Die Mitarbeiternummer darf nicht mehr als 25 Zeichen beinhalten. Bitte überprüfen Sie Ihre Eingabe.",
];

export const BLANK_CREDENTIALS_ERROR = {
  USER_ERROR: "*Bitte geben Sie Ihren Benutzernamen ein.",
  PASSWORD_ERROR: "*Bitte geben Sie Ihr Passwort ein.",
};

export const VWAG_GROUP = "VWAG";

export const LOGOUT_WARNING_MESSAGE =
  "Ihre Sitzung war längere Zeit inaktiv. Daher werden Sie nach Ablauf des Timers aus Sicherheitsgründen automatisch ausgeloggt.";

export const LOGOUT_WARNING_HEADER_LABEL = "Ablauf Sitzung";

export const EXTEND_SESSION_BUTTON_LABEL = "Sitzung verlängern";

export const FULL_DASH_ARRAY = 283;

export const TIME_LIMIT = 60;

export const ALLOWED_JSD_WIDGET_VWAG = "VWAG";

export const WARNING_BEFORE_IDLE_MILLISECONDS = 1 * 60 * 1000; // 1 minutes

export const BACKEND_BEFORE_IDLE_MILLISECONDS = 2 * 60 * 1000; // 2 minutes
